 
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useRef, useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import SVG from "react-inlinesvg";
import { useNavigate } from "react-router-dom";
import { toAbsoluteUrl } from "../../../../_helpers";
import { useSelector, useDispatch } from "react-redux";
import { Form, Modal } from "react-bootstrap";
import classNames from "classnames";
import { ErrorMessage } from "@hookform/error-message";
import { useIntl } from "react-intl";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { getBaseImageURL } from "../../../../../helpers";
import {
  changePassword,
  changePasswordStart,
} from "../../../../../store/actions";
import { useDisconnect } from "wagmi";
import "./QuickUser.scss";

export function QuickUser() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const intl = useIntl();
  const { disconnect } = useDisconnect();
  const MySwal = withReactContent(Swal);
  const {
    currentAdmin,
    changePasswordSuccessMsg,
    changePasswordErrorMsg,
    changePasswordLoader,
  } = useSelector((state) => state.adminAuth);
  const globalImagePath = useRef(getBaseImageURL());
  const [show, setShow] = useState(false);

  const {
    register,
    handleSubmit,
    reset,
    getValues,
    formState: { errors },
  } = useForm({ mode: "onChange" });

  useEffect(() => {
    if (changePasswordSuccessMsg) {
      MySwal.fire({
        title: intl.formatMessage({ id: "CHANGE.PASSWORD.SUCCESS" }),
        html: (
          <div>
            <p>{intl.formatMessage({ id: "CHANGE.PASSWORD.ALERT" })}</p>
            <p className="text-warning">
              {intl.formatMessage({ id: "CHANGE.PASSWORD.ALERT.BRIEF" })}
            </p>
          </div>
        ),
        icon: "warning",
        confirmButtonText: intl.formatMessage({ id: "GLOBAL.OKAY" }),
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then((result) => {
        if (result["isConfirmed"]) {
          dispatch(changePasswordStart(true));
          navigate("/logout");
        }
      });
    }
  }, [dispatch, changePasswordSuccessMsg]);

  useEffect(() => {
    if (changePasswordErrorMsg) {
      MySwal.fire({
        title: intl.formatMessage({ id: "ERROR" }),
        text: changePasswordErrorMsg?.message,
        icon: "error",
      });
      dispatch(changePasswordStart(true));
    }
  }, [dispatch, changePasswordErrorMsg]);

  const onChangePasswordSubmit = (data) => {
    dispatch(changePassword(data));
  };

  const handleClose = () => {
    setShow(false);
    reset();
  };

  const logoutClick = () => {
    const toggle = document.getElementById("kt_quick_user_toggle");
    if (toggle) {
      toggle.click();
    }
    navigate("/logout");
    disconnect();
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      const quickUserPanel = document.getElementById("kt_quick_user");

      if (
        !quickUserPanel ||
        !quickUserPanel.classList.contains("offcanvas-on")
      ) {
        return;
      }

      const quickUserToggle = document.getElementById("kt_quick_user_toggle");
      if (
        !quickUserPanel.contains(event.target) &&
        (!quickUserToggle || !quickUserToggle.contains(event.target))
      ) {
        const closeButton = document.getElementById("kt_quick_user_close");
        if (closeButton) {
          closeButton.click();
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  return (
    <div
      id="kt_quick_user"
      className="offcanvas offcanvas-right offcanvas quick-user-wrapper">
      <div className="offcanvas-header d-flex align-items-center justify-content-between p-4 gap-14 pb-5">
        <h3 className="fw-bold text-dark font-size-h5 m-0">Admin Profile</h3>
        <a
          href="#"
          className="btn btn-sm btn-light btn-dark py-1"
          id="kt_quick_user_close">
          Close
        </a>
      </div>

      <div className="offcanvas-body pt-0 p-5">
        <div className="d-flex flex-column gap-3 justify-content-center align-items-center">
          <div className="navi mt-2">
            <a href="#" className="navi-item">
              <span className="text-decoration-none text-dark font-size-sm">
                {currentAdmin?.email}
              </span>
            </a>
          </div>
          <div className="symbol symbol-100 me-5">
            <div
              className="quick-user-profile-image-wrapper"
              style={{
                backgroundImage: `url(${
                  currentAdmin?.photo
                    ? globalImagePath.current + currentAdmin?.photo
                    : toAbsoluteUrl("media/users/default.jpg")
                })`,
              }}
            />
          </div>
          <div className="d-flex flex-column">
            <p className="fw-bold font-size-h5 text-secondary text-center mb-0">
              {`${currentAdmin?.firstName} ${currentAdmin?.lastName}`}
            </p>
          </div>
        </div>

        <div className="quick-user-buttons-wrapper mt-5">
          <button
            className="btn change-password-btn d-flex align-items-center gap-2 w-100 fw-bold text-primary border-primary"
            onClick={() => {
              setShow(true);
            }}>
            <span>
              <SVG
                src={toAbsoluteUrl(
                  "media/svg/icons/General/change-password-icon.svg"
                )}></SVG>
            </span>
            Change Password
          </button>
          <button
            className="btn logout-btn d-flex align-items-center gap-2 w-100 fw-bold"
            onClick={logoutClick}>
            <span>
              <SVG
                src={toAbsoluteUrl(
                  "media/svg/icons/General/logout-icon.svg"
                )}></SVG>
            </span>
            Log Out
          </button>

          {/* <Link to="/user/profile" className="navi-item">
            <div className="navi-link">
              <div className="symbol symbol-40 bg-light me-3">
                <div className="symbol-label">
                  <span className="svg-icon svg-icon-md svg-icon-success">
                    <SVG src={toAbsoluteUrl("media/svg/icons/General/Notification2.svg")}></SVG>
                  </span>
                </div>
              </div>
              <div className="navi-text">
                <div className="fw-bold">My Profile</div>
                <div className="text-muted">Account settings and more</div>
              </div>
            </div>
          </Link> */}

          {/* <a href="/user/profile" className="navi-item">
            <div className="navi-link">
              <div className="symbol symbol-40 bg-light me-3">
                <div className="symbol-label">
                  <span className="svg-icon svg-icon-md svg-icon-warning">
                    <SVG src={toAbsoluteUrl("media/svg/icons/Shopping/Chart-bar1.svg")}></SVG>
                  </span>
                </div>
              </div>
              <div className="navi-text">
                <div className="fw-bold">My Messages</div>
                <div className="text-muted">Inbox and tasks</div>
              </div>
            </div>
          </a> */}

          {/* <a href="/user/profile" className="navi-item">
            <div className="navi-link">
              <div className="symbol symbol-40 bg-light me-3">
                <div className="symbol-label">
                  <span className="svg-icon svg-icon-md svg-icon-danger">
                    <SVG src={toAbsoluteUrl("media/svg/icons/Files/Selected-file.svg")}></SVG>
                  </span>
                </div>
              </div>
              <div className="navi-text">
                <div className="fw-bold">My Activities</div>
                <div className="text-muted">Logs and notifications</div>
              </div>
            </div>
          </a>

          <a href="/user/profile" className="navi-item">
            <div className="navi-link">
              <div className="symbol symbol-40 bg-light me-3">
                <div className="symbol-label">
                  <span className="svg-icon svg-icon-md svg-icon-primary">
                    <SVG src={toAbsoluteUrl("media/svg/icons/Communication/Mail-opened.svg")}></SVG>
                  </span>
                </div>
              </div>
              <div className="navi-text">
                <div className="fw-bold">My Tasks</div>
                <div className="text-muted">latest tasks and projects</div>
              </div>
            </div>
          </a>
        </div>

        <div className="separator separator-dashed my-7"></div>

        <div>
          <h5 className="mb-5">Recent Notifications</h5>

          <div className="d-flex align-items-center bg-light-warning rounded p-5 gutter-b">
            <span className="svg-icon svg-icon-warning me-5">
              <SVG src={toAbsoluteUrl("media/svg/icons/Home/Library.svg")} className="svg-icon svg-icon-lg"></SVG>
            </span>

            <div className="d-flex flex-column flex-grow-1 me-2">
              <a href="#" className="fw-normal text-dark-75 text-hover-primary font-size-lg mb-1">
                Another purpose persuade
              </a>
              <span className="text-muted font-size-sm">Due in 2 Days</span>
            </div>

            <span className="fw-bold text-warning py-1 font-size-lg">+28%</span>
          </div>

          <div className="d-flex align-items-center bg-light-success rounded p-5 gutter-b">
            <span className="svg-icon svg-icon-success me-5">
              <SVG src={toAbsoluteUrl("media/svg/icons/Communication/Write.svg")} className="svg-icon svg-icon-lg"></SVG>
            </span>
            <div className="d-flex flex-column flex-grow-1 me-2">
              <a href="#" className="fw-normal text-dark-75 text-hover-primary font-size-lg mb-1">
                Would be to people
              </a>
              <span className="text-muted font-size-sm">Due in 2 Days</span>
            </div>

            <span className="fw-bold text-success py-1 font-size-lg">+50%</span>
          </div>

          <div className="d-flex align-items-center bg-light-danger rounded p-5 gutter-b">
            <span className="svg-icon svg-icon-danger me-5">
              <SVG src={toAbsoluteUrl("media/svg/icons/Communication/Group-chat.svg")} className="svg-icon svg-icon-lg"></SVG>
            </span>
            <div className="d-flex flex-column flex-grow-1 me-2">
              <a href="#" className="font-weight-normel text-dark-75 text-hover-primary font-size-lg mb-1">
                Purpose would be to persuade
              </a>
              <span className="text-muted font-size-sm">Due in 2 Days</span>
            </div>

            <span className="fw-bold text-danger py-1 font-size-lg">-27%</span>
          </div>

          <div className="d-flex align-items-center bg-light-info rounded p-5">
            <span className="svg-icon svg-icon-info me-5">
              <SVG src={toAbsoluteUrl("media/svg/icons/General/Attachment2.svg")} className="svg-icon svg-icon-lg"></SVG>
            </span>

            <div className="d-flex flex-column flex-grow-1 me-2">
              <a href="#" className="font-weight-normel text-dark-75 text-hover-primary font-size-lg mb-1">
                The best product
              </a>
              <span className="text-muted font-size-sm">Due in 2 Days</span>
            </div>

            <span className="fw-bold text-info py-1 font-size-lg">+8%</span>
          </div> */}
        </div>
      </div>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title>Change Password</Modal.Title>
          <button
            type="button"
            className="btn py-1 btn-dark font-size-sm ms-auto"
            onClick={handleClose}>
            Close
          </button>
        </Modal.Header>
        <Form
          name="changePasswordForm"
          onSubmit={handleSubmit(onChangePasswordSubmit)}>
          <Modal.Body className="pt-0 py-6 px-4">
            <Form.Group className="mb-5 floating-input-field-wrapper">
              <Form.Control
                name="passwordCurrent"
                id="passwordCurrent"
                type="password"
                placeholder=" "
                className={classNames(
                  "form-control floating-input-field-item",
                  {
                    "is-invalid": errors.passwordCurrent,
                  }
                )}
                {...register("passwordCurrent", {
                  required: intl.formatMessage({ id: "CURRENT.PASSWORD.REQ" }),
                })}
              />
              <Form.Label className="floating-input-field-label ms-4 start-0">
                {intl.formatMessage({ id: "CURRENT.PASSWORD" })}
              </Form.Label>
              <ErrorMessage
                errors={errors}
                name="passwordCurrent"
                render={({ message }) => (
                  <div className="invalid-feedback">{message}</div>
                )}
              />
            </Form.Group>
            <Form.Group className="mb-5 floating-input-field-wrapper">
              <Form.Control
                name="password"
                id="password"
                type="password"
                placeholder=" "
                className={classNames(
                  "form-control floating-input-field-item",
                  {
                    "is-invalid": errors.password,
                  }
                )}
                {...register("password", {
                  required: intl.formatMessage({ id: "NEW.PASSWORD.REQ" }),
                  pattern: {
                    value:
                      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                    message: intl.formatMessage({ id: "yup.validPassword" }),
                  },
                })}
              />
              <Form.Label className="floating-input-field-label ms-4 start-0">
                {intl.formatMessage({ id: "NEW.PASSWORD" })}
              </Form.Label>
              <ErrorMessage
                errors={errors}
                name="password"
                render={({ message }) => (
                  <div className="invalid-feedback">{message}</div>
                )}
              />
            </Form.Group>
            <Form.Group className="mb-5 floating-input-field-wrapper">
              <Form.Control
                name="passwordConfirm"
                id="passwordConfirm"
                placeholder=" "
                type="password"
                className={classNames(
                  "form-control floating-input-field-item",
                  {
                    "is-invalid": errors.passwordConfirm,
                  }
                )}
                {...register("passwordConfirm", {
                  required: intl.formatMessage({ id: "CONFIRM.PASSWORD.REQ" }),
                  validate: (value) =>
                    value === getValues("password") ||
                    intl.formatMessage({ id: "CONFIRM.PASSWORD.ERROR" }),
                })}
              />
              <Form.Label className="floating-input-field-label ms-4 start-0">
                {intl.formatMessage({ id: "CONFIRM.PASSWORD" })}
              </Form.Label>
              <ErrorMessage
                errors={errors}
                name="passwordConfirm"
                render={({ message }) => (
                  <div className="invalid-feedback">{message}</div>
                )}
              />
            </Form.Group>
            <div className="d-flex justify-content-end gap-5">
              <button
                type="button"
                className="btn btn-outline-muted text-text-clr py-1"
                onClick={handleClose}>
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn-secondary px-4 text-white py-1"
                disabled={changePasswordLoader}>
                {changePasswordLoader ? (
                  <div className="spinner-border text-light" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                ) : (
                  "Submit"
                )}
              </button>
            </div>
          </Modal.Body>
        </Form>
      </Modal>
    </div>
  );
}
